import { FC, useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'

import { pollNotificationsEnabled } from 'AppSettings'
import {
  COUNT_UNREAD_NOTIFICATIONS,
  NotificationCountResponse
} from 'share/queries/notifications'
import Logo from 'components/atoms/Logo'
import Notifications from 'components/molecules/Notifications'
import Usermenu from 'components/molecules/Usermenu'

import { NavbarContainer, NavbarLeft, NavbarRight } from './styles'

interface NavbarProps {
  isAuthenticated?: boolean
  idToken?: string | null
  username?: string
}

const Navbar: FC<NavbarProps> = ({
  idToken = null,
  isAuthenticated = false,
  username
}) => {
  const [notificationCount, setNotificationCount] = useState(0)
  const [interval, setIntervalTimer] = useState<NodeJS.Timeout | null>(null)
  const [getNotificationCount, { data }] =
    useLazyQuery<NotificationCountResponse>(COUNT_UNREAD_NOTIFICATIONS, {
      fetchPolicy: 'network-only'
    })

  function setupGetNotificationCount() {
    if (isAuthenticated && idToken) {
      if (!interval) {
        getNotificationCount()
        setIntervalTimer(
          setInterval(() => {
            getNotificationCount()
          }, 15000)
        )
      }
    } else {
      if (interval) clearInterval(interval)
    }
  }

  function cleanUp() {
    if (interval) clearInterval(interval)
  }

  useEffect(() => {
    if (pollNotificationsEnabled) {
      setupGetNotificationCount()
    }

    return () => {
      cleanUp()
    }
  }, [isAuthenticated])

  useEffect(() => {
    if (data) {
      const count = data.notifications.get.length
      setNotificationCount(count)
    }
  }, [data])

  return (
    <NavbarContainer data-testid='NavbarID'>
      <NavbarLeft>
        <Logo />
      </NavbarLeft>
      <NavbarRight>
        {isAuthenticated && username && (
          <>
            <Notifications hasNotifications={Boolean(notificationCount)} />
            <Usermenu username={username} />
          </>
        )}
      </NavbarRight>
    </NavbarContainer>
  )
}

export default Navbar
